import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarAsciiArt_vue_vue_type_script_setup_true_lang_default from "./ScalarAsciiArt.vue.script.js";
/* empty css                             */
//#region src/components/ScalarAsciiArt/ScalarAsciiArt.vue
var ScalarAsciiArt_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarAsciiArt_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-4f827089"]]);
//#endregion
export { ScalarAsciiArt_default as default };

//# sourceMappingURL=ScalarAsciiArt.vue.js.map